import {
    apiGetPublisherDetails,
    apiUpdatePublisherDetails,
} from './api';

export async function getPublisherDetails ({ token } = {}) {
    this.env.errorStore.action = 'getPublisherDetails';
    const resolvedToken = token || this.env.userStore.publisher?.token;

    const res = await apiGetPublisherDetails({
        token: resolvedToken,
        traceId: this.env.traceId,
    });

    if (res.data && res.data.data && res.data.data.getPublishers) {
        const edges = res.data.data.getPublishers.edges;
        if (edges && edges.length > 0) {
            this.publisherDetails = edges[0].node;
        }
    }
}

export async function updatePublisherDetails ({ publicAccess }) {
    this.env.errorStore.action = 'updatePublisherDetails';
    const publisher = this.env.userStore.publisher;

    const res = await apiUpdatePublisherDetails({
        publicAccess,
        token: publisher.token,
        traceId: this.env.traceId,
    });

    if (res.data && res.data.data && res.data.data.updatePublisherDetails) {
        const edges = res.data.data.updatePublisherDetails.edges;
        if (edges && edges.length > 0) {
            this.publisherDetails = edges[0].node;
        }
    }
}
